import { render } from "./BankOfChinaApprovedDialog.vue?vue&type=template&id=49ae4ac2&scoped=true"
import script from "./BankOfChinaApprovedDialog.vue?vue&type=script&lang=ts"
export * from "./BankOfChinaApprovedDialog.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-49ae4ac2"

export default script